import LanguageIcon from "@/assets/icons/language.svg";
import { MentionV4 } from "@/types/MentionCard";
import TextButton, { TextButtonProps } from "@components/TextButton";

import { useMentionCard } from "../../context";

const Translate: React.FunctionComponent<
  Omit<TextButtonProps, "icon" | "onClick"> & {
    mentions: MentionV4[];
    toKey?: keyof MentionV4;
  }
> = ({ mentions, toKey = "amended_text", ...props }) => {
  const { translateMention, unTranslateMention } = useMentionCard();
  return (
    <TextButton
      {...props}
      icon={LanguageIcon}
      onClick={() => {
        for (const m of mentions) {
          m.translated
            ? unTranslateMention(m, toKey)
            : translateMention(m, toKey);
        }
      }}
      data-testid="translation-link"
    >
      {mentions[0].translated
        ? L.MENTIONS_SHOW_ORIGINAL
        : L.MENTIONS_SHOW_TRANSLATION}
    </TextButton>
  );
};

export default Translate;
